import {
  cellRenderAdminMessageStatus,
  cellRenderParseDataAndTimeWithSeconds
} from '../../../utils/functions';

/** Список полей */
const metSapDataGrid = [
  {
    dataField: 'msgCounter',
    caption: 'ID сообщения',
    dataType: 'string'
  },
  {
    dataField: 'msgDateTime',
    caption: 'Время',
    dataType: 'datetime',
    cellRender: cellRenderParseDataAndTimeWithSeconds
  },
  {
    dataField: 'msgId',
    caption: 'Тип',
    dataType: 'number'
  },
  {
    dataField: 'msgDesc',
    caption: 'Описание типа',
    dataType: 'string'
  },
  {
    dataField: 'sapGuid',
    caption: 'sapGuid',
    dataType: 'string'
  },
  {
    dataField: 'status',
    caption: 'Статус',
    dataType: 'number',
    cellRender: cellRenderAdminMessageStatus
  },
  {
    dataField: 'attemptsCount',
    caption: 'attemptsCount',
    dataType: 'string'
  },
  {
    dataField: 'errorText',
    caption: 'errorText',
    dataType: 'string'
  },
  {
    dataField: 'evnCounter',
    caption: 'Идентификатор внутренний',
    notVisible: true,
    dataType: 'number'
  },
  {
    dataField: 'modDateTime',
    caption: 'Время изменения',
    dataType: 'datetime',
    cellRender: cellRenderParseDataAndTimeWithSeconds
  },
  {
    dataField: 'queueId',
    caption: 'queueId',
    dataType: 'string'
  }
];

export default metSapDataGrid;
